export type APIError = {
  non_field_errors: string[];
}

// register PayPal subscription
export type PayPalRegisterSubscriptionRequest = {
  amplitude_device_id: string;
  subscription_id: string,
  internal_id: string,
  fbclickid: string,
  fbp: string,
  source_url: string,
  onboarding_email: string,
  onboarding_answers?: any,
  enable_checklist_pdf_email?: boolean;
}

export type PayPalRegisterSubscriptionRequestV2 = {
  amplitude_device_id: string;
  paypal_plan_id: string,
  internal_id: string,
  fbclickid: string,
  fbp: string,
  source_url: string,
  redirect_urls?: {
    return_url: string;
    cancel_url: string;
  } | null,
  onboarding_email: string,
  onboarding_answers?: any,
  enable_checklist_pdf_email?: boolean;
}

export type PayPalRegisterSubscriptionV2Response = {
  subscription_id: string,
  approval_link: string,
}
  
export type PayPalRegisterSubscriptionResponse = {
  redirect_url: string,
}

// Create Stripe subscription

export type StripeCreateSubscriptionRequest = {
  amplitude_device_id: string;
  payment_method_id: string,
  stripe_plan_id: string,
  internal_id: string,
  email: string,
  fbclickid: string,
  fbp: string,
  source_url: string,
  onboarding_email: string,
  onboarding_answers?: any,
}

export type StripeCheckoutSubscriptionResponse = {
  redirect_url: string,
}

export type StripeConfigResponse = {
  publishableKey: string
}

export type PaypalConfigResponse = {
  client_id: string
}

export type WebCatalogProductDuration = {
  unit: string,
  value?: number | null,
  trial_period_unit?: string | null,
  trial_period_value?: number | null,
}
export type WebCatalogProduct = {
  id: string,
  position: number,
  amount: string,
  intro_amount?: string | null,
  duration: WebCatalogProductDuration,
  paypal_plan_id: string,
  stripe_plan_id: string,
  trial_period_days?: number | null,
  trial_amount?: string | null,
  internal_product_id?: string | null,
};

export type WebCatalogDigitalProduct = {
  product_key: string;
  price: string;
}

export type WebCatalogDigitalProductOfer = {
  id: number;
  price: string;
  product_key: string;
}

export type WebCatalogDigitalProductList = WebCatalogDigitalProduct[];

export type WebCatalogDigitalProductOferList = WebCatalogDigitalProductOfer[];

export type StripePurchaseDigitalProductRequest = {
  amplitude_device_id: string;
  email: string,
  payment_method_id: string,
  digital_product_offer_id: number,
  fbclickid: string,
  fbp: string,
  source_url: string,
  internal_id: string,
}

export type PayPalСreateDigitalProductRequest = {
  amplitude_device_id: string;
  digital_product_offer_id: string,
  fbclickid: string,
  fbp: string,
  source_url: string,
  internal_id: string,
}

export type PayPalRegisterDigitalProductRequest = {
  amplitude_device_id: string;
  order_id: string,
  fbclickid: string,
  fbp: string,
  source_url: string,
  internal_id: string,
}

export type WebCatalogConfigResponse = WebCatalogProduct[];

export function createEmptyWebCatalogProduct(): WebCatalogProduct {
	return {
		id: '',
		position: 0,
		amount: '',
		duration: {
			unit: 'week',
		},
		paypal_plan_id: '',
		stripe_plan_id: '',
	};
}

export function createEmptyWebCatalogDigitalProductList(): WebCatalogDigitalProduct {
	return (
    {
      product_key: '',
      price: '',
    }
  );
}
